<section class="drawer dark resources">
  <h1
    id="ResourcesModalTitleNameId"
    class="head drawer-head resource-drawer-head"
    >
    <i class="material-icons">attach_file</i>Resources
  </h1>
  <a (click)="toggleDrawer()" appSwipeShow class="resources"
    ><i class="material-icons">chevron_left</i></a
    >
    @if (pageTemplateId == null) {
      <a
        class="head resources-send-multiple"
        (click)="openMailResourceModal(null)"
        placement="bottom"
        container="body"
        tooltip="Send Multiple"
        >
        <span class="material-icons email-icon">email</span>
        <span class="email-text">Send Multiple</span>
      </a>
    }

    <ng-scrollbar track="all">
      <ul
        [ngClass]="{ 'mr-top-list': pageTemplateId !== null }"
        id="resource-list-{{ container.id }}"
        class="resources-list pd-bottom-85"
        >
        <li
          cdkDropList
          cdkDropListOrientation="vertical"
          (cdkDropListDropped)="drop($event, 1)"
          class="no-padding-margin"
          >
          <ul class="no-padding-margin">
            @for (
              resource of container.resourceFolders | orderBy : 'orderBy'
              ; track
              resource) {
              <li
                class="folder-list"
          [ngClass]="{
            'active-folder resource-list-title': selectedFolder == resource.id
          }"
                id="folder-{{ resource.id }}"
                cdkDrag
                [cdkDragDisabled]="languageId !== defaultLanguageId"
                >
                <div class="mask"></div>
                <a
                  class="folder-title pointer d-flex align-items-center"
                  (click)="openFolder(resource.id)"
                  href="javascript:void(0);"
                  >
                  @if (selectedFolder == resource.id) {
                    <span
                      ><i class="material-icons resource-list-title"
                      >folder_open</i
                      ></span
                      >
                    } @else {
                      <span
                        ><i class="material-icons resource-list-title">folder</i></span
                        >
                      }
                      {{ resource.name }}
                    </a>
                    <div class="resource-icons">
                      @if (checkResourceForNullAssets(resource, true)) {
                        <a
                          target="_blank"
                          (click)="downloadFolder(resource)"
                          placement="bottom"
                          container="body"
                          tooltip="Download"
                          >
                          <span><i class="material-icons">cloud_download</i></span>
                        </a>
                      }
                      @if (!pageTemplateId && checkResourceForNullAssets(resource)) {
                        <a
                          placement="bottom"
                          container="body"
                          tooltip="Email Resource"
                          (click)="openMailResourceModal(resource, resource.name)"
                          >
                          <span><i class="material-icons">mail_outline</i></span>
                        </a>
                      }
                      @if (
                        languageId === defaultLanguageId &&
                        checkResourceForNullAssets(resource, true)
                        ) {
                        <a
                          placement="bottom"
                          container="body"
                          tooltip="Copy Resource Shareable Link"
              (click)="
                copyResourceShareableLink({
                  companyId: companyId,
                  pageTemplateId: pageTemplateId,
                  playbookId: container.playbookId,
                  pageId: container.id,
                  folderId: resource.id,
                  languageId: languageId,
                  pageFrom: pageFrom
                })
              "
                          >
                          <span><i class="material-icons">link</i></span>
                        </a>
                      }
                      <div class="edit-icons" style="cursor: pointer">
                        <a
                          (click)="openfolderModal(resource, AddEditfolder)"
                          placement="bottom"
                          container="body"
                          tooltip="Edit Item"
                          >
                          <i class="material-icons res-edit-icons">create</i>
                        </a>
                        @if (languageId === defaultLanguageId) {
                          <a
                            (click)="openDeleteFolderModal(resource, deleteFolder)"
                            placement="bottom"
                            container="body"
                            tooltip="Delete Item"
                            class=""
                            >
                            <i class="material-icons res-edit-icons">delete</i>
                          </a>
                        }
                        @if (languageId === defaultLanguageId) {
                          <a
                            placement="bottom"
                            container="body"
                            tooltip="Reorder Item"
                            class="reorder"
                            cdkDragHandle
                            >
                            <i class="material-icons res-edit-icons">open_with</i>
                          </a>
                        }
                      </div>
                    </div>
                    <ul
                      id="folder-content-{{ resource.id }}"
                      [hidden]="selectedFolder !== resource.id"
                      cdkDropList
                      cdkDropListOrientation="vertical"
                      (cdkDropListDropped)="drop($event, 2, resource.id)"
                      >
                      @for (folderRss of resource.resources | orderBy : 'orderBy'; track folderRss) {
                        <li
                          id="resource-{{ folderRss.id }}"
                          cdkDrag
                          [cdkDragDisabled]="languageId !== defaultLanguageId"
                          >
                          @if (checkResourceForNullAssets(folderRss, false, true)) {
                            <span
                              >
                              @switch (folderRss.type) {
                                @case (1) {
                                  <a
                                    class="resource-list-title pointer"
                                    (click)="openResourceUrl(folderRss)"
                                    target="blank"
                                    [hidden]="isOffline"
                                    >
                                    {{ folderRss.title }}
                                  </a>
                                }
                                @case (1) {
                                  <a
                                    class="resource-list-title pointer"
                                    (click)="openResourceUrl(folderRss)"
                                    [hidden]="!isOffline"
                                    >
                                    {{ folderRss.title }}
                                  </a>
                                }
                                @case (2) {
                                  <a
                                    class="resource-list-title pointer"
                                    [hidden]="isOffline"
                                    [routerLink]="'/home/resourcelanding'"
                  [queryParams]="{
                    resourceId: folderRss.id,
                    languageId: languageId,
                    pageTemplateId: pageTemplateId,
                    pageFrom: pageFrom
                  }"
                                    target="blank"
                                    >
                                    {{ folderRss.title }}
                                  </a>
                                }
                                @case (2) {
                                  <a
                                    class="resource-list-title pointer"
                                    [hidden]="!isOffline"
                                    (click)="openFile(folderRss)"
                                    >
                                    {{ folderRss.title }}
                                  </a>
                                }
                                @default {
                                  <a
                                    [hidden]="isOffline"
                                    id="resourcesListId"
                                    class="resource-list-title pointer"
                                    [routerLink]="'/home/resourcelanding'"
                  [queryParams]="{
                    resourceId: folderRss.id,
                    languageId: languageId,
                    pageTemplateId: pageTemplateId,
                    pageFrom: pageFrom
                  }"
                                    target="blank"
                  [ngClass]="{
                    'not-active-link': !checkResourceForNullAssets(folderRss)
                  }"
                                    >{{ folderRss.title }}</a
                                    >
                                    <a
                                      class="resource-list-title pointer"
                                      (click)="openFile(folderRss)"
                                      [hidden]="!isOffline"
                                      >{{ folderRss.title }}</a
                                      >
                                    }
                                  }
                                </span>
                              }
                              @if (!checkResourceForNullAssets(folderRss, false, true)) {
                                <a
                                  class="resource-list-title"
                                  >
                                  {{ folderRss.title }}
                                </a>
                              }
                              <div class="resource-icons">
                                @if (
                                  !pageTemplateId &&
                                  folderRss.type != 1 &&
                                  checkResourceForNullAssets(folderRss)
                                  ) {
                                  <a
                  (click)="
                    maintainClick(folderRss); downloadFile($event, folderRss)
                  "
                                    placement="bottom"
                                    container="body"
                                    tooltip="Download"
                                    >
                                    <!-- [href]="openResource(folderRss)" -->
                                    <!-- target="_blank" -->
                                    <span><i class="material-icons">cloud_download</i></span>
                                  </a>
                                }
                                @if (
                                  !pageTemplateId && checkResourceForNullAssets(folderRss)
                                  ) {
                                  <a
                                    placement="bottom"
                                    container="body"
                                    tooltip="Email Resource"
                                    (click)="openMailResourceModal(folderRss)"
                                    >
                                    <span><i class="material-icons">mail_outline</i></span>
                                  </a>
                                }
                                @if (
                                  !pageTemplateId &&
                                  folderRss.type != 1 &&
                                  checkResourceForNullAssets(folderRss)
                                  ) {
                                  <a
                                    placement="bottom"
                                    container="body"
                                    tooltip="Copy Resource Shareable Link"
                  (click)="
                    copyResourceShareableLink({
                      resourceId: folderRss.id,
                      languageId: languageId,
                      pageTemplateId: pageTemplateId,
                      pageFrom: pageFrom
                    })
                  "
                                    >
                                    <span><i class="material-icons">link</i></span>
                                  </a>
                                }
                                <div class="edit-icons" style="cursor: pointer">
                                  <a
                                    (click)="openResourceModal(folderRss)"
                                    placement="bottom"
                                    container="body"
                                    tooltip="Edit Item"
                                    >
                                    <i class="material-icons res-edit-icons">create</i>
                                  </a>
                                  @if (languageId === defaultLanguageId) {
                                    <a
                                      (click)="deleteResource(folderRss, resource.id)"
                                      placement="bottom"
                                      container="body"
                                      tooltip="Delete Item"
                                      class=""
                                      >
                                      <i class="material-icons res-edit-icons">delete</i>
                                    </a>
                                  }
                                  @if (languageId === defaultLanguageId) {
                                    <a
                                      placement="bottom"
                                      container="body"
                                      tooltip="Reorder Item"
                                      class="reorder"
                                      cdkDragHandle
                                      >
                                      <i class="material-icons res-edit-icons">open_with</i>
                                    </a>
                                  }
                                </div>
                              </div>
                            </li>
                          }
                        </ul>
                      </li>
                    }
                  </ul>
                </li>
                <li
                  cdkDropList
                  cdkDropListOrientation="vertical"
                  (cdkDropListDropped)="drop($event, 3)"
                  class="no-padding-margin"
                  >
                  <ul class="no-padding-margin">
                    @for (resource of container.resources | orderBy : 'orderBy'; track resource) {
                      <li
                        id="resource-{{ resource.id }}"
                        cdkDrag
                        [cdkDragDisabled]="languageId !== defaultLanguageId"
                        >
                        @if (checkResourceForNullAssets(resource, true, false)) {
                          <span
                            >
                            @switch (resource.type) {
                              @case (1) {
                                @if (checkResourceForNullAssets(resource)) {
                                  <a
                                    class="resource-list-title pointer"
                                    (click)="openResourceUrl(resource)"
                                    target="blank"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                                @if (!checkResourceForNullAssets(resource)) {
                                  <a
                                    class="resource-list-title"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                              }
                              @case (2) {
                                @if (checkResourceForNullAssets(resource)) {
                                  <a
                                    class="resource-list-title pointer"
                                    [routerLink]="'/home/resourcelanding'"
                [queryParams]="{
                  resourceId: resource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                }"
                                    target="blank"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                                @if (!checkResourceForNullAssets(resource)) {
                                  <a
                                    class="resource-list-title"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                              }
                              @default {
                                @if (checkResourceForNullAssets(resource)) {
                                  <a
                                    id="resourcesListId"
                                    class="resource-list-title pointer"
                                    [routerLink]="'/home/resourcelanding'"
                [queryParams]="{
                  resourceId: resource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                }"
                                    target="blank"
                [ngClass]="{
                  'not-active-link': !checkResourceForNullAssets(resource)
                }"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                                @if (!checkResourceForNullAssets(resource)) {
                                  <a
                                    id="resourcesListId"
                                    class="resource-list-title"
                                    >
                                    {{ resource.title }}
                                  </a>
                                }
                              }
                            }
                          </span>
                        }
                        <div class="resource-icons">
                          @if (
                            pageTemplateId == null &&
                            resource.type != 1 &&
                            checkResourceForNullAssets(resource)
                            ) {
                            <a
                              (click)="maintainClick(resource); downloadFile($event, resource)"
                              placement="bottom"
                              container="body"
                              tooltip="Download"
                              >
                              <!-- target="_blank" -->
                              <!-- [href]="openResource(resource)" -->
                              <span><i class="material-icons">cloud_download</i></span>
                            </a>
                          }
                          @if (
                            pageTemplateId == null && checkResourceForNullAssets(resource)
                            ) {
                            <a
                              placement="bottom"
                              container="body"
                              tooltip="Email Resource"
                              (click)="openMailResourceModal(resource)"
                              >
                              <span><i class="material-icons">mail_outline</i></span>
                            </a>
                          }
                          @if (
                            pageTemplateId == null &&
                            languageId === defaultLanguageId &&
                            resource.type != 1 &&
                            checkResourceForNullAssets(resource)
                            ) {
                            <a
                              placement="bottom"
                              container="body"
                              tooltip="Copy Resource Shareable Link"
              (click)="
                copyResourceShareableLink({
                  resourceId: resource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                })
              "
                              >
                              <span><i class="material-icons">link</i></span>
                            </a>
                          }
                          <div class="edit-icons" style="cursor: pointer">
                            <a
                              (click)="openResourceModal(resource)"
                              placement="bottom"
                              container="body"
                              tooltip="Edit Item"
                              >
                              <i class="material-icons res-edit-icons">create</i>
                            </a>
                            @if (checkResourceForNullAssets(resource)) {
                              <a
                                (click)="deleteResource(resource)"
                                placement="bottom"
                                container="body"
                                tooltip="Delete Item"
                                class=""
                                >
                                <i class="material-icons res-edit-icons">delete</i>
                              </a>
                            }
                            @if (languageId === defaultLanguageId) {
                              <a
                                placement="bottom"
                                container="body"
                                tooltip="Reorder Item"
                                class="reorder"
                                cdkDragHandle
                                >
                                <i class="material-icons res-edit-icons">open_with</i>
                              </a>
                            }
                          </div>
                        </div>
                      </li>
                    }
                  </ul>
                </li>
                @if (languageId === defaultLanguageId) {
                  <li
                    id="addResource"
                    class="add-res-li"
                    style="cursor: pointer"
                    >
                    <a
                      id="addResourceButtonId"
                      (click)="openResourceModal(null)"
                      class="add-resource-link"
                      >
                      <span class="add-res-text">Add Resource</span>
                      <i class="material-icons add-res-icon">add</i></a
                      >
                    </li>
                  }
                  @if (languageId === defaultLanguageId) {
                    <li
                      id="addfolder"
                      class="add-res-li"
                      style="cursor: pointer"
                      >
                      <a
                        id="addfolderButtonId"
                        (click)="openfolderModal(null, AddEditfolder)"
                        class="add-resource-link"
                        >
                        <span class="add-res-text">Add Folder</span>
                        <i class="material-icons add-res-icon">add</i></a
                        >
                      </li>
                    }
                  </ul>
                </ng-scrollbar>
              </section>

              @for (
                cont of container.containers
                | filterBy : { type: 1, on: true }
                | orderBy : 'displayOrder'
                ; track
                cont) {
                <app-resource-lists
                  [resContainer]="cont"
                  [languageId]="languageId"
                  [companyId]="companyId"
                  >
                </app-resource-lists>
              }

              <ng-template #AddEditfolder>
                <div class="modal-content">
                  <div class="modal-header">
                    {{ editFolder !== null ? "Edit" : "Add" }} Folder
                    <i
                      class="material-icons"
                      data-bs-dismiss="modal"
                      (click)="closeEditfolderModal()"
                      >close</i
                      >
                    </div>
                    <div class="modal-body mt-1 mb-4 me-3">
                      <div class="form-group row align-items-center">
                        <label for="Title" class="col-sm-3 control-label">Title</label>
                        <div
                          class="col-sm-9 error-container"
                          [ngClass]="{ error: folderTitle.errors }"
                          >
                          <input
                            type="text"
                            id="Title"
                            [formControl]="folderTitle"
                            name="Title"
                            style="text-transform: none"
                            class="form-control vplaybook__form__inputs"
                            placeholder="Max. 100 characters"
                            />
                          @if (
                            folderTitle.errors &&
                            (folderTitle.dirty || folderTitle.value !== '')
                            ) {
                            <div
                              class="text-danger"
                              >
                              @if (folderTitle.errors.required) {
                                <div>
                                  Please enter the title
                                </div>
                              }
                              @if (folderTitle.errors.maxlength) {
                                <div>
                                  Your title Should not be more than 100 Characters
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn vPlaybookDefaultButton btn__btn-default"
                        data-bs-dismiss="modal"
                        (click)="closeEditfolderModal()"
                        >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn__btn-default btn__orange"
                        (click)="saveFolderBlock()"
                        >
                        Save
                      </button>
                    </div>
                  </div>
                </ng-template>

                <ng-template #deleteFolder>
                  <div class="modal-content">
                    <div class="modal-body mt-1 mb-4 me-3">
                      <p>
                        Are you sure you want to delete this resource folder? All resources
                        saved to this folder will be moved to the Resouce Drawer.
                      </p>
                      <p>
                        <b>Note:</b> if you want to delete the folder and all of its contents,
                        click "Delete All"
                      </p>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn vPlaybookDefaultButton btn__btn-default"
                        data-bs-dismiss="modal"
                        (click)="deleteResourcefolder(true)"
                        >
                        Delete All
                      </button>
                      <button
                        type="button"
                        class="btn vPlaybookDefaultButton btn__btn-default"
                        data-bs-dismiss="modal"
                        (click)="closeDeletefolderModal()"
                        >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn__btn-default btn__orange"
                        (click)="deleteResourcefolder(false)"
                        >
                        Ok
                      </button>
                    </div>
                  </div>
                </ng-template>
